import type { JSX } from 'react';
import { FormSection } from '@ksyos/design-system';
import type { RecipientSchema } from '@common/validation/customControls/parameterSchemas';
import { Profession } from '@common/enums';
import { recipientSchema } from '@common/validation/customControls/parameterSchemas';
import { useServiceWorkflowStepParameters } from '@frontend/utils/hooks/useProcessActivityContext';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';
import { SelectProcessActivityPerformerFromProcessActorOrganization } from '../../processActivityPerformer/SelectProcessActivityPerformerFromProcessActorOrganization';

export function BariPreDietPlanAppointmentEdit(): JSX.Element {
    const { recipientActivityIds } = useServiceWorkflowStepParameters<RecipientSchema>(recipientSchema);

    return (
        <FormSection>
            <SelectProcessActivityPerformerFromProcessActorOrganization
                profession={Profession.dietitian}
                recipientActivityIds={recipientActivityIds}
            />
            <TextAreaFormGroup
                fieldKey="toelichting"
                label="Toelichting"
                placeholder="Typ je toelichting..."
            />
        </FormSection>
    );
}
